<template>
  <div v-if="!isLoadingContents">
    <template v-if="hasRecommendCellList">
      <p class="no-result-text">
        &apos;<em class="point">{{ searchTitle }}</em>&apos; 검색결과가 없어요.<br>
        <strong class="recommend">비슷한 작품을 추천해 드려요</strong>
      </p>
      <SearchRecommendCellList
        :total-count="totalCount"
        :cell-list="recommendContentList"
        :thumbnail-info="thumbnailInfo"
      />
    </template>

    <template v-else>
      <section class="search-empty no-result">
        <p class="dsc">
          &apos;<em class="point">{{ searchTitle }}</em>&apos; 검색결과가 없어요.<br>
          이런 검색어는 어떠세요?
        </p>
        <SearchRecommendTagList
          :key="`${searchTitle}_recommend_tag`"
          :total-count="totalCount"
          :is-loading="isLoading"
          :search-title="searchTitle"
        />
      </section>
    </template>
    <!--    FIXME: angksehwjs (무한도전) 검색결과 보기 -->
    <!--    <template v-if="hasChangeWord">-->
    <!--    <div class="result-more-link">-->
    <!--        <a href="#">&apos;angksehwjs&apos; 검색결과 보기</a>-->
    <!--    </div>-->
    <!--    </template>-->
  </div>
</template>

<script>
import _ from 'lodash'
import SearchRecommendTagList from '@/components/search/data/SearchRecommendTagList'
import SearchRecommendCellList from '@/components/search/view/SearchRecommendCellList'
import { getSearchRecommendContents } from '@/common/utils/request'
import { getThumbnailInfo } from '@/common/utils/common'
export default {
  name: 'SearchEmptyMessage',
  components: {
    SearchRecommendTagList,
    SearchRecommendCellList
  },
  props: {
    searchTitle: {
      type: String
    },
    isLoading: {
      type: Boolean
    },
    totalCount: {
      type: Number
    },
    recommendContentType: {
      type: String
    },
    changeWord: {
      type: String
    }
  },
  data () {
    return {
      recommendContentList: [],
      isLoadingContents: true,
      thumbnailInfo: {}
    }
  },
  methods: {
    checkRecommendContents () {
      if (this.recommendContentType) {
        this.setRecommendContentsList()
      } else {
        this.isLoadingContents = false
      }
    },
    setRecommendContentsList () {
      this.isLoadingContents = true
      const PATH_CELL_LIST = ['cell_toplist', 'celllist']
      const PATH_CELL_TYPE = ['cell_toplist', 'cell_type']
      getSearchRecommendContents({
        contenttype: this.recommendContentType,
        keyword: this.searchTitle,
        limit: 20
      }).then(({ data }) => {
        this.recommendContentList = _.get(data, PATH_CELL_LIST, [])
        this.thumbnailInfo = getThumbnailInfo(_.get(data, PATH_CELL_TYPE, {}))
        this.isLoadingContents = false
      })
    }
  },
  computed: {
    hasChangeWord () {
      return this.changeWord !== '' && this.changeWord !== undefined
    },
    hasRecommendCellList () {
      return this.recommendContentList.length > 0
    }
  },
  created () {
    this.checkRecommendContents()
  }
}
</script>
<style lang="scss" scoped>
  .no-result-text {
    width: auto;
    margin: 0 100px;
  }
</style>

